module.exports = __webpack_public_path__ + "static/img/13.e91bddf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/13.png
// module id = iOeL
// module chunks = 0